<template>
  <section class="spaces">
    <h1>Espaces</h1>
    <div class="g-container">
      <router-link v-for="space in spaces" :key="space.id" :to="{ name: 'editor-entities', params: { spaceId: space.spaceId } }" class="box">
        <img src="/images/espace1.svg" alt="">
        <span>{{ space.name }}</span>
        <small>{{ space.description }}</small>
      </router-link>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'spaces',
  components: {
  },
  data() {
    return {
      spaces: null,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.spaces = await api.getSpaces();
    },
  },
};
</script>

<style lang="sass">
.spaces
  .box
    display: flex
    flex-direction: column
    align-items: center
    justify-content: space-between
    padding: 4rem 1rem
    width: 300px
    background: #FFFFFF
    border-radius: 10px
    transition: all ease-in 0.2s
    &:hover
      background: lighten(#001861, 75%)
    & ~ .box
      margin-left: 1rem

    img
      display: block
      margin: 0 1rem 1.5rem
      height: 150px
    span
      font-weight: bold

</style>
